// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&family=Plus+Jakarta+Sans:ital,wght@0,200..800;1,200..800&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.editCoverPhotoContainer {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: 15px;
}

.uploadContainer {
    display: flex;
    align-items: center;
    gap: 1vh;
    width: 90%;
    height: 10vh;
    background-color: #070F0F;
    padding: 30px;
    display: flex;
    box-sizing: border-box;
    border-radius: 12px;
    gap: 10px;
    cursor: pointer;
}

.cameraIcon {
    width: 30px;
    height: 30px;
}

.uploadText {
    color: #FFF;
    font-family: Inter;
    font-size: 20px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
}

.coverPhoto {
    position: relative;
    width: 90%;
    height: 50vh;
    background-color: #070F0F;
    border-radius: 8px;
    overflow: hidden;
}

.coverVideo {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.captureButton {
    background-color: rgba(90, 175, 154, 0.8);
    color: white;
    border: none;
    padding: 12px 24px;
    border-radius: 8px;
    cursor: pointer;
    font-family: Inter;
    font-size: 16px;
    font-weight: 500;
    transition: background-color 0.3s ease;
}

.captureButton:hover {
    background-color: rgba(90, 175, 154, 1);
}

.captureMain {
    position: absolute;
    left: 50%;
    bottom: 20px;
    transform: translateX(-50%);
}

.captureControls {
    position: absolute;
    bottom: 20px;
    left: 0;
    right: 0;
    display: flex;
    justify-content: center;
    gap: 20px;
}

.uploadButton {
    background-color: rgba(90, 175, 154, 0.9);
}

@media (max-width: 1640px) {
    .captureButton {
        padding: 10px 20px;
        border-radius: 8px;
        font-size: 16px;
        font-weight: 500;
    }

    .uploadContainer {
        padding: 28px;
        border-radius: 12px;
    }

    .uploadText {
        font-size: 18px;
    }
    .cameraIcon {
        width: 28px;
        height: 28px;
    }
}

@media (max-width: 1440px) {
    .captureButton {
        padding: 8px 16px;
        border-radius: 8px;
        font-size: 14px;
        font-weight: 500;
    }

    .uploadContainer {
        padding: 26px;
        border-radius: 12px;
    }

    .uploadText {
        font-size: 16px;
    }
    .cameraIcon {
        width: 26px;
        height: 26px;
    }
}

@media (max-width: 1280px) {
    .captureButton {
        padding: 8px 16px;
        border-radius: 7px;
        font-size: 14px;
        font-weight: 500;
    }

    .uploadContainer {
        padding: 24px;
        border-radius: 10px;
    }

    .uploadText {
        font-size: 14px;
    }
    .cameraIcon {
        width: 24px;
        height: 24px;
    }
}

@media (max-width: 1024px) {
    .captureButton {
        padding: 6px 12px;
        border-radius: 6px;
        font-size: 12px;
    }

    .uploadContainer {
        padding: 22px;
        border-radius: 8px;
    }

    .uploadText {
        font-size: 12px;
    }
    .cameraIcon {
        width: 22px;
        height: 22px;
    }
}`, "",{"version":3,"sources":["webpack://./src/Components/EditCoverPhoto/EditCoverPhoto.css"],"names":[],"mappings":"AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,UAAU;IACV,YAAY;IACZ,yBAAyB;IACzB,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,yCAAyC;IACzC,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,sCAAsC;AAC1C;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,YAAY;IACZ,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,QAAQ;IACR,aAAa;IACb,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI;QACI,kBAAkB;QAClB,kBAAkB;QAClB,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,aAAa;QACb,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;IACA;QACI,WAAW;QACX,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,iBAAiB;QACjB,kBAAkB;QAClB,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,aAAa;QACb,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;IACA;QACI,WAAW;QACX,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,iBAAiB;QACjB,kBAAkB;QAClB,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,aAAa;QACb,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;IACA;QACI,WAAW;QACX,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,iBAAiB;QACjB,kBAAkB;QAClB,eAAe;IACnB;;IAEA;QACI,aAAa;QACb,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;IACA;QACI,WAAW;QACX,YAAY;IAChB;AACJ","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&family=Plus+Jakarta+Sans:ital,wght@0,200..800;1,200..800&display=swap\");\n\n.editCoverPhotoContainer {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n    gap: 15px;\n}\n\n.uploadContainer {\n    display: flex;\n    align-items: center;\n    gap: 1vh;\n    width: 90%;\n    height: 10vh;\n    background-color: #070F0F;\n    padding: 30px;\n    display: flex;\n    box-sizing: border-box;\n    border-radius: 12px;\n    gap: 10px;\n    cursor: pointer;\n}\n\n.cameraIcon {\n    width: 30px;\n    height: 30px;\n}\n\n.uploadText {\n    color: #FFF;\n    font-family: Inter;\n    font-size: 20px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: normal;\n}\n\n.coverPhoto {\n    position: relative;\n    width: 90%;\n    height: 50vh;\n    background-color: #070F0F;\n    border-radius: 8px;\n    overflow: hidden;\n}\n\n.coverVideo {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n}\n\n.captureButton {\n    background-color: rgba(90, 175, 154, 0.8);\n    color: white;\n    border: none;\n    padding: 12px 24px;\n    border-radius: 8px;\n    cursor: pointer;\n    font-family: Inter;\n    font-size: 16px;\n    font-weight: 500;\n    transition: background-color 0.3s ease;\n}\n\n.captureButton:hover {\n    background-color: rgba(90, 175, 154, 1);\n}\n\n.captureMain {\n    position: absolute;\n    left: 50%;\n    bottom: 20px;\n    transform: translateX(-50%);\n}\n\n.captureControls {\n    position: absolute;\n    bottom: 20px;\n    left: 0;\n    right: 0;\n    display: flex;\n    justify-content: center;\n    gap: 20px;\n}\n\n.uploadButton {\n    background-color: rgba(90, 175, 154, 0.9);\n}\n\n@media (max-width: 1640px) {\n    .captureButton {\n        padding: 10px 20px;\n        border-radius: 8px;\n        font-size: 16px;\n        font-weight: 500;\n    }\n\n    .uploadContainer {\n        padding: 28px;\n        border-radius: 12px;\n    }\n\n    .uploadText {\n        font-size: 18px;\n    }\n    .cameraIcon {\n        width: 28px;\n        height: 28px;\n    }\n}\n\n@media (max-width: 1440px) {\n    .captureButton {\n        padding: 8px 16px;\n        border-radius: 8px;\n        font-size: 14px;\n        font-weight: 500;\n    }\n\n    .uploadContainer {\n        padding: 26px;\n        border-radius: 12px;\n    }\n\n    .uploadText {\n        font-size: 16px;\n    }\n    .cameraIcon {\n        width: 26px;\n        height: 26px;\n    }\n}\n\n@media (max-width: 1280px) {\n    .captureButton {\n        padding: 8px 16px;\n        border-radius: 7px;\n        font-size: 14px;\n        font-weight: 500;\n    }\n\n    .uploadContainer {\n        padding: 24px;\n        border-radius: 10px;\n    }\n\n    .uploadText {\n        font-size: 14px;\n    }\n    .cameraIcon {\n        width: 24px;\n        height: 24px;\n    }\n}\n\n@media (max-width: 1024px) {\n    .captureButton {\n        padding: 6px 12px;\n        border-radius: 6px;\n        font-size: 12px;\n    }\n\n    .uploadContainer {\n        padding: 22px;\n        border-radius: 8px;\n    }\n\n    .uploadText {\n        font-size: 12px;\n    }\n    .cameraIcon {\n        width: 22px;\n        height: 22px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
